import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { GALLERY } from "../lib/constants";

const Gallery = () => {
  const { t, lang } = useLanguage();
  const [activeIdx, setActiveIdx] = useState(null);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="section-padding bg-white"
    >
      <div className="container-page">
        <div className="max-w-3xl">
          <span className="chip mb-5">{t.gallery.eyebrow}</span>
          <h2
            data-testid="gallery-title"
            className="font-display font-black text-4xl sm:text-5xl text-navy leading-[1.05]"
          >
            {t.gallery.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground/75 leading-relaxed">
            {t.gallery.lead}
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {GALLERY.map((g, i) => (
            <div
              key={g.id}
              data-testid={`gallery-item-${i}`}
              className="group relative rounded-2xl overflow-hidden border border-border"
              onMouseEnter={() => setActiveIdx(i)}
              onMouseLeave={() => setActiveIdx(null)}
            >
              <div className="aspect-[4/5] relative overflow-hidden">
                <img
                  src={g.before}
                  alt={`Avant - ${lang === "fr" ? g.title_fr : g.title_en}`}
                  className="absolute inset-0 h-full w-full object-cover transition-opacity duration-700"
                  style={{ opacity: activeIdx === i ? 0 : 1 }}
                  loading="lazy"
                  width="900"
                  height="1125"
                />
                <img
                  src={g.after}
                  alt={`Après - ${lang === "fr" ? g.title_fr : g.title_en}`}
                  className="absolute inset-0 h-full w-full object-cover transition-opacity duration-700"
                  style={{ opacity: activeIdx === i ? 1 : 0 }}
                  loading="lazy"
                  width="900"
                  height="1125"
                />
                <div className="absolute left-3 top-3 rounded-full bg-white/95 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-navy">
                  {activeIdx === i ? "Après" : "Avant"}
                </div>
                <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-[#0A192F]/90 via-[#0A192F]/50 to-transparent">
                  <h3 className="font-display text-white font-bold">
                    {lang === "fr" ? g.title_fr : g.title_en}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 text-xs text-muted-foreground italic">
          Images anonymisées. Résultats non contractuels.
        </p>
      </div>
    </section>
  );
};

export default Gallery;
